import { render, staticRenderFns } from "./ApiPage.vue?vue&type=template&id=319369c4&scoped=true&"
import script from "./ApiPage.vue?vue&type=script&lang=js&"
export * from "./ApiPage.vue?vue&type=script&lang=js&"
import style0 from "./ApiPage.vue?vue&type=style&index=0&id=319369c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319369c4",
  null
  
)

export default component.exports